import React from 'react'
import block from 'bem-cn'

import { ReactComponent as LiveChatSVG } from 'shared/img/live-chat.svg'
import { ReactComponent as WhatsappSVG } from 'shared/img/whatsapp.svg'

import { useGetAgentLinks } from 'shared/hooks/useGetAgentLinks'

import './AgentLinkButton.scss'

const b = block('agent-link-btn')

export const AgentLinkButton = ({ isStatic = false }: { isStatic?: boolean }) => {
  const { whatsapp, liveChat } = useGetAgentLinks()

  if (liveChat) {
    return (
      <div className={b('wrapper', { isStatic })}>
        <a href={liveChat.link} target="_blank" rel="noreferrer">
          <LiveChatSVG />
        </a>
      </div>
    )
  }

  if (whatsapp) {
    return (
      <div className={b('wrapper', { isStatic })}>
        <a href={whatsapp?.link ?? '#'} target="_blank" rel="noreferrer">
          <WhatsappSVG />
        </a>
      </div>
    )
  }

  return null
}
